import { Checkbox, Space, Form } from 'antd';
import React, { useEffect, useState } from 'react';
import '../SurveyAnswer.less';

// 排序题
const Sort: React.FC = ({ body, required = true, id, optionList, form, num }: { body?: string; required?: boolean; optionList?: Array<string>; num?: number; id?: number; form?: any }) => {
    const [options, setOptions] = useState(optionList);
    const [value, setValue] = useState([]);

    const onChange = (checkedValues: any) => {
        console.log('checked = ', checkedValues);
        setValue(checkedValues);
        let checkArr: any = [];
        let noCheckArr: any = [];
        optionList
            && optionList.forEach((item: any) => {
                if (checkedValues.indexOf(item.id) !== -1) {
                    checkArr[checkedValues.indexOf(item.id)] = item;
                } else {
                    noCheckArr.push(item);
                }
            });
        setOptions(checkArr.concat(noCheckArr));
    };

    // 问卷回显缓存
    useEffect(() => {
        let formData = localStorage.getItem('initFormData');
        if (formData) {
            let val = JSON.parse(formData)[`${id}-9`];
            if (val) {
                setValue(val);
                let checkArr: any = [];
                let noCheckArr: any = [];
                optionList
                    && optionList.forEach((item: any) => {
                        if (val.indexOf(item.id) !== -1) {
                            checkArr[val.indexOf(item.id)] = item;
                        } else {
                            noCheckArr.push(item);
                        }
                    });
                setOptions(checkArr.concat(noCheckArr));
            }
        }
    }, []);

    useEffect(() => {
        document.querySelectorAll(`.sort-${id} .ant-checkbox-inner`).forEach((el, index: any) => {
            el.setAttribute('check-index', index + 1);
        });
    }, [options]);

    return (
        <div className={`sort-topic sort-${id}`}>
            <Form.Item
                name={`${id}-9`}
                rules={[
                    {
                        required,
                        validator: async (rule, value) => {
                            if (required) {
                                if (!value || (value && value.length === 0)) {
                                    throw '该题为必答题，请作答后提交。';
                                } else if (value && options && value.length !== options.length) {
                                    throw '请选择所有选项的顺序';
                                }
                            } else {
                                if (value && value.length && options && value.length !== options.length) {
                                    throw '请选择所有选项的顺序';
                                }
                            }
                        },
                    },
                ]}
                label={<div className="label-flex" style={{ display: 'flex' }} dangerouslySetInnerHTML={{ __html: num + '. ' + body }}></div>}
            >
                <Checkbox.Group onChange={onChange} value={value}>
                    <Space direction="vertical" style={{ width: '100%' }}>
                        {options && options.length
                            ? options.map((option: any) => (
                                  <Checkbox key={option.id} value={option.id}>
                                      {option.content}
                                  </Checkbox>
                              ))
                            : null}
                    </Space>
                </Checkbox.Group>
            </Form.Item>
        </div>
    );
};

export default Sort;
